<template>
  <div id="ios">
      <mycarousel></mycarousel>
      <div class="ios1 titleBox">
          <p class="title">专业APP定制开发，让APP应用制作更简单</p>
          <ul>
            <li v-for="(item,index) in ios1" :key="index"  class="wow animate__animated animate__fadeInUp">
              <img :src="item.icon" alt="">
              <p class="ios1Title">{{item.title}}</p>
              <p class="ios1Subtitle">{{item.subtitle}}</p>
            </li>
          </ul>
      </div>
      <div class="ios2 titleBox">
        <p class="title">十年技术开发，服务百万用户</p>
        <p class="subtitle">精准捕捉用户需求，快速高效开发功能，秒出方案</p>
        <ul>
          <li class="wow animate__animated animate__fadeInLeft"><img src="@/assets/ios/ios2.png" alt=""></li>
          <li class="wow animate__animated animate__fadeInRight">
              <div v-for="(item,index) in ios2" :key="index">
                <p class="iosTitle">{{item.title}}</p>
                <p class="iosSubtitle">{{item.subtitle}}</p>
              </div>
          </li>
        </ul>
      </div>

      <div class="ios3 titleBox">
        <p class="title">专业团队让您买的放心</p>
        <p class="subtitle">十年开发定制服务经验，更专业，更优质</p>
        <ul>
          <li>
              <div v-for="(item,index) in ios3" :key="index" class="wow animate__animated animate__fadeInLeft">
                <p class="iosTitle">{{item.title}}</p>
                <p class="iosSubtitle">{{item.subtitle}}</p>
              </div>
          </li>
          <li  class="wow animate__animated animate__fadeInRight"><img src="@/assets/ios/ios3.png" alt=""></li>
        </ul>
      </div>

      <div class="ios4 titleBox">
        <p class="title">七大服务流程，全程为您保驾护航</p>
        <p class="subtitle">朝睿专业项目开发流程，全身心投入，只为客户满意</p>
        <ul>
          <li class="wow animate__animated animate__fadeInLeft"><img src="@/assets/ios/ios4.png" alt=""></li>
          <li>
              <div v-for="(item,index) in ios4" :key="index"  class="wow animate__animated animate__fadeInRight">
                <p class="iosTitle">{{item.title}}</p>
                <p class="iosSubtitle">{{item.subtitle}}</p>
              </div>
          </li>
        </ul>
      </div>
      <div class="ios5 titleBox">
        <p class="title">全方位运营服务护航</p>
        <p class="subtitle">专业顾问全程知道，从0到1无忧起步</p>
        <ul>
          <li v-for="(item,index) in ios5" :key="index"  class="wow animate__animated animate__fadeInUp">
            <img :src="item.icon" alt="">
            <div>
              <p class="iosTitle">{{item.title}}</p>
              <p class="iosSubtitle">{{item.subtitle}}</p>
            </div>
          </li>
        </ul>
      </div>
      <mytechnology></mytechnology>
  </div>
</template>

<script>
import mycarousel from  '@/components/carousel/carousel.vue'
import mytechnology from  '@/components/technology/technology.vue'
export default {
  components: {
    mycarousel,
    mytechnology
  },
  data(){
    return {
      ios1:[
        {
          icon:require('@/assets/ios/ios1icon1.png'),
          title:"方案测定",
          subtitle:"产品讲解，方案定制"
        },
        {
          icon:require('@/assets/ios/ios1icon2.png'),
          title:"在线咨询",
          subtitle:"上手指导，交付服务"
        },
        {
          icon:require('@/assets/ios/ios1icon3.png'),
          title:"APP上线服务",
          subtitle:"服务经理，全程操作"
        },
        {
          icon:require('@/assets/ios/ios1icon4.png'),
          title:"UI设计",
          subtitle:"风格多变，样式精美"
        },
        {
          icon:require('@/assets/ios/ios1icon5.png'),
          title:"程序开发",
          subtitle:"高速效率，质量过关"
        },
        {
          icon:require('@/assets/ios/ios1icon6.png'),
          title:"定制功能",
          subtitle:"功能定制，按需定制"
        },
        {
          icon:require('@/assets/ios/ios1icon7.png'),
          title:"数据安全",
          subtitle:"数据保障，安全可靠"
        },
                {
          icon:require('@/assets/ios/ios1icon8.png'),
          title:"行业广泛",
          subtitle:"按需定制，广泛适用"
        },
        {
          icon:require('@/assets/ios/ios1icon9.png'),
          title:"质量保障",
          subtitle:"兼容测试，真机调试"
        },
        {
          icon:require('@/assets/ios/ios1icon10.png'),
          title:"专业团队",
          subtitle:"技术实力，运营实力"
        }
      ],
      ios2:[
        {
          title:"高效技术开发，系统安全保障",
          subtitle:"功能梳理、原型策划、UI设计、程序开发、系统测试、质量监督包括迭代运维，自主研发框架、高并发、高可用、多层级、平滑迁移、跨平台支持"
        },
        {
          title:"成熟系统架构加上服务器方案",
          subtitle:"基于LINUX系统、APACHE&NGINX服务器、PHP开发语言配合MYSQL数据库，分布式数据库服务器、分布式web服务器、大数据负载全球节点接入"
        },
        {
          title:"全程服务支持，多平台定制",
          subtitle:"售前咨询、需求分析、调研团队、建设问题、处理售后、支持迭代建议外加上多平台可定制，不仅仅只限于IOS"
        }
      ],
      ios3:[
        {
          title:"业内顶尖技术实力，专业可靠",
          subtitle:"10年技术开发定制服务经验，标准化开发流程，更专业，更优质。 专业定制，领先SAAS化产品，更成熟，更具性价比"
        },
        {
          title:"十年专业团队，百万用户选择",
          subtitle:"囊括教授，博士，硕士等互联网全领域专家团 专注解决应用开发中的各类难题，能给予功能策划，运营推广，销售策略方面最专业实用的意见"
        },
        {
          title:"质量保障，检测到您满意再交付",
          subtitle:"快速验证APP兼容性，完成安装/启动/运行/卸载操作，收集出错信息，截图日志等，APP透过全面缺陷发现，跟踪及处理，让上线版本更稳健"
        }
      ],
      ios4:[
        {
          title:"沟通评估，商务沟通立项",
          subtitle:"收集需求 — 整理需求 — 评估工期"
        },
        {
          title:"头脑风暴，会议确认原型策划",
          subtitle:"界面交互设计 — 原型DEMO出图 — 风格样式确定研发讨论 — 接口调试 "
        },
        {
          title:"UI界面设计，还原原型DEMO",
          subtitle:"根据交互原型制作设计稿，界面风格样式做到客户满意为止"
        },
        {
          title:"程序开发，功能对接沟通",
          subtitle:"架构设计 — 界面布局 — 功能实现 — 数据对接 — 版本管理"
        },
        {
          title:"功能测试，BUG检测，界面检测",
          subtitle:"单元测试 — 真机测试 — 功能测试 — 测试跟踪 — 出测试报告"
        },
        {
          title:"测试APP，正式上线加验收",
          subtitle:"正式发布到应用市场，客户即可验收"
        },
        {
          title:"后期维护，问题可随时反馈",
          subtitle:"及时跟进帮助客户 — 处理上线后的维护工作"
        }
      ],
      ios5:[
        {
          icon:require('@/assets/ios/ios5icon1.png'),
          title:"完善的定制化建站服务",
          subtitle:"包含店铺SEO优化、商品上架、支付对接、店铺装修、店铺基础功能配置等定制基础建站服务和大促活动策划，0基础也能快速拥有高转化店铺。"
        },
        {
          icon:require('@/assets/ios/ios5icon2.png'),
          title:"专业的运营服务",
          subtitle:"资深广告运营团队拥有丰富优化经验，从SEM、SNS广告投放优化、KOLiKOC开拓、粉丝页内容运营等全方位助力出海营销。"
        },
        {
          icon:require('@/assets/ios/ios5icon3.png'),
          title:"优质的短视频营销服务",
          subtitle:"“短视频营销中心”为客户提供从创意到拍摄到后期等—体化的短视频营销服务，月均产量10000+条，创意内容提高转化。"
        },
        {
          icon:require('@/assets/ios/ios5icon4.png'),
          title:"顾问咨询及增值服务",
          subtitle:"提供选品建议及广告投放策划咨询、团队建设等顾问式咨询服务，提供大客户数据分析支持，全面助力品牌经营决策及业绩提升。"
        }
      ]
    }
  }
}
</script>

<style lang="scss">
  :root {
    --web-max-width: 1920px;
    --web-min-width: 1300px;
  } 
  .titleBox{
    .title{
      font-size: 28px;
      font-weight: 400;
      color: #333333;
      padding-top: 60px;
      text-align: center;
      margin-bottom: 12px;
    }
    .subtitle{
      font-size: 16px;
      font-weight: 400;
      color: #A2A5AC;
      text-align: center;
      margin-bottom: 60px;
    }
  }
  #ios{
    .ios1{
      min-width:var(--web-min-width);
      // max-width:var(--web-max-width);
      margin:0 auto;
      ul{
        width: 1200px;
        margin:60px auto 0;
        display: flex;
        flex-wrap: wrap;
        text-align: center;
        img{
          width: 60px;
        }
        .ios1Title{
          font-size: 18px;
          font-weight: 400;
          color: #333333;
        }
        .ios1Subtitle{
          font-size: 16px;
          font-weight: 400;
          color: #A2A5AC;
        }
        li:nth-child(-n+4){
          margin-right: 120px;
        }
        li:nth-child(n+6):nth-child(-n+9){
          margin-right: 120px;
        }
        li:nth-child(-n+5){
          margin-bottom: 60px;
        }
      }
    }
    .ios2{
      min-width:var(--web-min-width);
      // max-width:var(--web-max-width);
      margin:0 auto;
      ul{
        width: 1200px;
        display: flex;
        margin:0 auto;
        align-items: center;
        img{
          width: 500px;
          margin-right: 100px;
        }
        .iosTitle{
          font-size: 24px;
          font-weight: 500;
          color: #161E30;
          margin-bottom: 8PX;
          border-left: 3px solid #0071EF;
          padding-left: 12px;
        }
        .iosSubtitle{
          font-size: 14px;
          font-weight: 400;
          color: #161E30;
          margin-bottom: 40PX;
        }
      }
    }
    .ios3{
      min-width:var(--web-min-width);
      // max-width:var(--web-max-width);
      margin:0 auto;
      background: #F8F9FC;
      ul{
        width: 1200px;
        display: flex;
        margin:0 auto;
        align-items: center;
        img{
          width: 500px;
          margin-left: 100px;
        }
        .iosTitle{
          font-size: 24px;
          font-weight: 500;
          color: #161E30;
          margin-bottom: 8PX;
          border-left: 3px solid #0071EF;
          padding-left: 12px;
        }
        .iosSubtitle{
          font-size: 14px;
          font-weight: 400;
          color: #161E30;
          margin-bottom: 40PX;
        }
      }
    }
    .ios4{
      min-width:var(--web-min-width);
      // max-width:var(--web-max-width);
      margin:0 auto;
      ul{
        width: 1200px;
        display: flex;
        margin:0 auto;
        align-items: center;
        img{
          width: 500px;
          margin-right: 100px;
        }
        .iosTitle{
          font-size: 24px;
          font-weight: 500;
          color: #161E30;
          margin-bottom: 8PX;
          border-left: 3px solid #0071EF;
          padding-left: 12px;
        }
        .iosSubtitle{
          font-size: 14px;
          font-weight: 400;
          color: #161E30;
          margin-bottom: 40PX;
        }
      }
    }
    .ios5{
      min-width:var(--web-min-width);
      // max-width:var(--web-max-width);
      margin:0 auto;
      background: #F8F9FC;
      padding-bottom: 80px;
      ul{
        width: 1200px;
        display: flex;
        margin:0 auto;
        align-items: center;
        flex-wrap: wrap;
        li{
          width: 580px;
          background: #FFFFFF;
          border-radius: 8px 8px 8px 8px;
          display: flex;
          padding: 45px;
          align-items: center;
          img{
            width: 90px;
            height: 90px;
            margin-right: 34px;
          }
          .iosTitle{
            font-size: 24px;
            font-weight: bold;
            color: #161E30;
            margin-bottom: 24px;
          }
          .iosSubtitle{
            font-size: 14px;
            font-weight: 400;
            color: #161E30;
          }
        }
        li:nth-child(2n+1){
          margin-right: 40px;
        }
        li:nth-child(-n+2){
          margin-bottom: 40px;
        }
      }
    }
  }
</style>